import type SVGProps from '~/components/icons/svg-props'

export function LeaderboardIcon(props: SVGProps) {
  const { variant = 'outlined', width = '24', height = '24', ...rest } = props

  return variant === 'outlined' ? (
    <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_4571_33587"
        // style="mask-type:alpha"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4571_33587)">
        <path
          d="M4 19H8.3365V11H4V19ZM9.8365 19H14.1635V5H9.8365V19ZM15.6635 19H20V13H15.6635V19ZM2.5 18.6923V11.3078C2.5 10.8106 2.677 10.385 3.031 10.031C3.385 9.677 3.81058 9.5 4.30775 9.5H8.3365V5.30775C8.3365 4.81058 8.5135 4.385 8.8675 4.031C9.2215 3.677 9.64708 3.5 10.1442 3.5H13.8558C14.3529 3.5 14.7785 3.677 15.1325 4.031C15.4865 4.385 15.6635 4.81058 15.6635 5.30775V11.5H19.6923C20.1894 11.5 20.615 11.677 20.969 12.031C21.323 12.385 21.5 12.8106 21.5 13.3077V18.6923C21.5 19.1894 21.323 19.615 20.969 19.969C20.615 20.323 20.1894 20.5 19.6923 20.5H4.30775C3.81058 20.5 3.385 20.323 3.031 19.969C2.677 19.615 2.5 19.1894 2.5 18.6923Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ) : (
    <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_4562_33946"
        // style="mask-type:alpha"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4562_33946)">
        <path
          d="M3.78852 20.5C3.53252 20.5 3.31785 20.4133 3.14452 20.24C2.97135 20.0668 2.88477 19.8522 2.88477 19.596V10.4078C2.88477 10.1474 2.97135 9.93108 3.14452 9.75875C3.31785 9.58625 3.53252 9.5 3.78852 9.5H6.80777C7.06377 9.5 7.27843 9.58667 7.45177 9.76C7.62493 9.93317 7.71152 10.1478 7.71152 10.404V19.5923C7.71152 19.8526 7.62493 20.0689 7.45177 20.2413C7.27843 20.4138 7.06377 20.5 6.80777 20.5H3.78852ZM10.3973 20.5C10.1376 20.5 9.92152 20.4133 9.74902 20.24C9.57668 20.0668 9.49052 19.8522 9.49052 19.596V4.404C9.49052 4.14783 9.5771 3.93317 9.75027 3.76C9.92343 3.58667 10.1381 3.5 10.3943 3.5H13.6028C13.8624 3.5 14.0785 3.58667 14.251 3.76C14.4233 3.93317 14.5095 4.14783 14.5095 4.404V19.596C14.5095 19.8522 14.4229 20.0668 14.2498 20.24C14.0766 20.4133 13.8619 20.5 13.6058 20.5H10.3973ZM17.1923 20.5C16.9363 20.5 16.7216 20.4138 16.5483 20.2413C16.3751 20.0688 16.2885 19.855 16.2885 19.6V12.3997C16.2885 12.1447 16.3751 11.9311 16.5483 11.7587C16.7216 11.5863 16.9363 11.5 17.1923 11.5H20.2115C20.4675 11.5 20.6822 11.5863 20.8555 11.7587C21.0287 11.9312 21.1153 12.145 21.1153 12.4V19.6003C21.1153 19.8552 21.0287 20.0689 20.8555 20.2413C20.6822 20.4138 20.4675 20.5 20.2115 20.5H17.1923Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
